import Vue from 'vue'
import App from './App'
import router from './router'

import Vuetify from 'vuetify'
import '../static/css/MaterialIcons.css';
require('vuetify/dist/vuetify.min.css');

Vue.use(Vuetify, {
    theme: {
        primary: '#3f51b5',
        secondary: '#b0bec5',
        accent: '#8c9eff',
        error: '#b71c1c'
    }
});

Vue.config.productionTip = false

new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: {App}
});



// WEBPACK FOOTER //
// ./src/main.js